import { useState, useEffect, useRef } from "react";
import axios from 'axios'
import { globalPublicData } from "globalPublicData";
import { useSelector, useDispatch } from "react-redux";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';

import CreateIcon from '@mui/icons-material/Create';

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";


import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";


import MDTypography from "components/MDTypography";
import { useLocation, useNavigate } from "react-router-dom";



import HierarchyFormInformation from "page-sections/HierarchyFormInformation/HierarchyFormInformation";
import BuildingBasicInformationSection from "page-sections/building/BuildingBasicInformationSection";
import BuildingDetailedInformationSection from "page-sections/building/BuildingDetailedInformationSection";
import BuildingSubmitArea from "page-sections/building/BuildingSubmitArea";
import FMCContactInformationSection from "page-sections/contactInformationForms/FMCContactInformationSection";
import JTCContactInformationSection from "page-sections/contactInformationForms/JTCContactInformationSection";

import { defaultInputState } from "page-sections/building/utils";
import AuditTrailSection from "page-sections/auditTrail/AuditTrailSection";
import ProgressSectionBSD from "page-sections/approvalSections/ProgressSectionBSD";
import TicketConversationSection from "page-sections/ticketConversation/TicketConversationSection";
import { useCookies } from "react-cookie";
import { defaultInputErrorState } from "page-sections/building/utils";
import EstatePGBuildingSubmitArea from "page-sections/EstatePGBuildingSubmitArea/EstatePGBuildingSubmitArea";

const ViewBuildingTicketPage = (props) => {

    const navigate = useNavigate()
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const user =  useSelector(state => state.user)
    const [cookies, setCookie, removeCookie] = useCookies()
    const axiosConfig = {
        headers: {
          Authorization: `Bearer ${user.token}`
        }
      }

    const [viewMode, setViewMode] = useState(true)
    const disableIdField = true

    const [inputs, setInputs] = useState(location.state.Object_Data || defaultInputState)
    const [inputErrorState, setInputErrorState] = useState(defaultInputErrorState)
    // const [inputs, setInputs] = useState(defaultInputState)
    const [ticket, setTicket] = useState(location.state || {})
    const [activeStep, setActiveStep] = useState(1)
    const [disableCommentInput, setDisableCommentInput] = useState(false)
    const [auditData, setAuditData] = useState([])

    const defaultNoShowState = {
        show: false,
        text: "NA",
        color: "info"
    }

    const [approveButton, setApproveButton] = useState({
        show: false,
        text: "Approve Request",
        color: "info"
    })

    const [cancelButton, setCancelButton] = useState({
        show: false,
        text: "Cancel Request",
        color: "error"
    })

    const [assignBackButton, setAssignBackButton] = useState({
        show: false,
        text: "Route Back Request",
        color: "info"
    })

    const [rejectButton, setRejectButton] = useState({
        show: false,
        text: "Reject Request",
        color: "error"
    })

    const [updateTicketButton, setUpdateTicketButton] = useState({
        show: false,
        text: "Update Ticket",
        color: "info"
    })


    useEffect(()=>{
        if (
            user.roleClaims.includes("amm.hod") && 
            user.roleClaims.includes("amm.approvemanagebuilding") && 
            ticket.Status === "PendingHODApproval"
        ){
            setApproveButton({
                show: true,
                text: "Approve Request",
                color: "info"
            })

            setRejectButton({
                show: true,
                text: "Reject Request",
                color: "error"
            })

            setAssignBackButton({
                show: true,
                text: "Route Back",
                color: "warning"
            })
        }

        if (
            user.roleClaims.includes("amm.bsd") && 
            user.roleClaims.includes("amm.managebuilding") &&
            user.email === ticket.Requester_Email &&
            ticket.Status !== "Cancelled" &&
            ticket.Status !== "Approved" &&
            ticket.Status !== "Rejected"
        ){
            setCancelButton({
                show: true,
                text: "Cancel Request",
                color: "error"
            })

            if (ticket.Status === "Draft") {
                setViewMode(false)
                setUpdateTicketButton({
                    show: true,
                    text: "Update Request",
                    color: "info"
                })
            }

        }

    },[])

    useEffect(()=>{
        console.log("hod? ", user.roleClaims.includes("amm.hod"))
        console.log("ticket status? ", ticket.Status === "PendingHODApproval")
        console.log("approvemanagebuilding? ", user.roleClaims.includes("amm.approvemanagebuilding"))
    },[user,ticket])

    const handleInputChange = (event) => {
        event.persist()
        setInputs({ ...inputs, [event.target.name]: event.target.value })
    }

    useEffect(() => {
        const fetchData = async () => {
            var cosmosId = queryParams.get("id")
            console.log('[ViewBuildingTicketPage][fetchData] cosmosId is: ', cosmosId)
            var idToQuery = cosmosId || location.state.id
            const url =
                globalPublicData.baseEndpoint
                + "/ammticket/getticketbyuuid/"
                + idToQuery + "/false"

            console.log('[ViewBuildingTicketPage][fetchData] url is: ', url)
            const res = await axios.get(url, axiosConfig)
            console.log("[ViewBuildingTicketPage] res.data is: ", res.data)
            console.log("[ViewBuildingTicketPage] res.data[0].Object_Data is: ", res.data[0].Object_Data)
            
            if (res.data[0].Ticket_Action_Type === "Delete"){
                var getObjectByIdUrl = globalPublicData.baseEndpoint + "/building/getbuildingbyuuid//" + res.data[0].Object_Data.id + "/false"
                const objRes = await axios.get(getObjectByIdUrl, axiosConfig)
                console.log('[fetcData] delete objRes.data[0] is: ', objRes.data[0])
                setInputs(objRes.data[0])
            } else {
                setInputs(res.data[0].Object_Data)
            }

            setTicket(res.data[0])

            if (res.data[0].Status === "PendingHODApproval"){
                if (!user.roleClaims.includes("amm.hod")){ setDisableCommentInput(true)}
                setActiveStep(1)
            } else if (res.data[0].Status === "Approved"){
                setActiveStep(2)
                setDisableCommentInput(true)
            }
            // setAuditData(res.data)
        }
        
        fetchData()
        
    }, [])

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={5}>
                <Card sx={{ width: "100%" }}>
                    <ProgressSectionBSD activeStep={activeStep} />
                    <MDBox display="flex">
                        <MDTypography variant="h1" sx={{ mt: 2, mb: 1, ml: 3, fontSize: "2rem" }}>
                            {"Building Ticket (" + ticket.Ticket_Action_Type + ")"} 
                        </MDTypography>
                    </MDBox>
                    <HierarchyFormInformation
                        inputs={inputs}
                        inputErrorState={inputErrorState}
                        setInputs={setInputs}
                        viewMode={viewMode}
                        disableIdField={disableIdField}
                        showPropertyGroupFields
                        openCollapse={false}
                    />

                    <BuildingBasicInformationSection
                        inputs={inputs} 
                        inputErrorState={inputErrorState}
                        handleInputChange={handleInputChange}
                        setInputs={setInputs}
                        viewMode={viewMode}
                        disableIdField={disableIdField}
                    />

                    <BuildingDetailedInformationSection
                        inputs={inputs}
                        inputErrorState={inputErrorState}
                        handleInputChange={handleInputChange}
                        setInputs={setInputs}
                        viewMode={viewMode}
                        disableIdField={disableIdField}
                        openCollapse={false}
                    />
                    {/* <FMCContactInformationSection 
                        inputs={inputs}
                        handleInputChange={handleInputChange}
                        viewMode={viewMode}
                        openCollapse={false}
                    />
                    <JTCContactInformationSection
                        inputs={inputs}
                        handleInputChange={handleInputChange}
                        viewMode={viewMode}
                        openCollapse={false}
                    /> */}
                    <MDBox mt={7}>     
                        <TicketConversationSection
                            ticket={ticket}
                            setTicket={setTicket}
                            disableCommentInput={disableCommentInput}
                        />
                        <MDBox p={2} mt={1}>
                            <EstatePGBuildingSubmitArea
                                inputs={inputs}
                                setInputErrorState={setInputErrorState}
                                approveButton={approveButton}
                                assignBackButton={assignBackButton}
                                rejectButton={rejectButton}
                                cancelButton={cancelButton}
                                updateTicketButton={updateTicketButton}
                                updateBatchTicketButton={defaultNoShowState}
                                ticket={ticket}
                                createEndpoint="/building/create"
                                updateEndpoint="/building/update"
                                deleteEndpoint="/building/delete"
                                editRedirectUrl="/fb/app/home/edit-building"
                                defaultInputErrorState={defaultInputErrorState}
                            />
                        </MDBox>
                    </MDBox>
                </Card>  
            </MDBox>
            <Footer />
        </DashboardLayout>
    )
}

export default ViewBuildingTicketPage


ViewBuildingTicketPage.defaultProps = {
    viewMode: false,
    disableIdField: false

};